// @flow
import React from "react";

import SectionHeader from "./commons/SectionHeader";
import Section from "./commons/Section";

const Contact = () => {
  return (
    <div style={{}}>
      <SectionHeader>Contact</SectionHeader>
      <Section>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            flexWrap: "wrap",
            textAlign: "left"
          }}
        >
          <div style={{ flex: 1, minWidth: 330 }}>
            <table>
              <tbody>
                <tr>
                  <td>
                    <i className="material-icons" style={{ color: "#222" }}>
                      home
                    </i>
                  </td>
                  <td style={{ lineHeight: "19px" }}>
                    Champagne Bruno De Villepin<br />
                    2 rue Pasteur<br />
                    51480 Boursault
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{ flex: 1, minWidth: 330 }}>
            <table>
              <tbody>
                <tr>
                  <td>
                    <i className="material-icons" style={{ color: "#222" }}>
                      smartphone
                    </i>
                  </td>
                  <td>0687103839</td>
                </tr>
                <tr>
                  <td>
                    <i className="material-icons" style={{ color: "#222" }}>
                      email
                    </i>
                  </td>
                  <td style={{ fontSize: 16 }}>
                    contact@champagnedevillepin.fr
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <p style={{ textAlign: "justify" }}>
          Nous proposons des visites du vignoble, de la cuverie, des caves ainsi
          que des dégustations sur rendez vous.
        </p>
      </Section>
    </div>
  );
};

export default Contact;



// WEBPACK FOOTER //
// ./src/Contact.js